export const SOURCE_TYPES = {
  METASEARCH: 'metasearch',
  LOGGEDIN_METASEARCH: 'loggedInMetasearch',
} as const
